import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  shouldShowResults,
  useSearchBarState,
} from 'Components/AdvisorApp/Header/ClientSearchBar/BetaSearchBar/SearchBarContext';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import ResultComponent from './ResultComponent';

const styles = (theme) => ({
  root: {
    paddingTop: theme.spacing(1),
  },
  result: {
    marginTop: theme.spacing(1),
  },
  title: {
    padding: theme.spacing(1),
    pointerEvents: 'none',
    userSelect: 'none',
  },
});

const ResultList = ({
  className,
  classes,
  selectedDOMId,
}) => {
  const searchBarState = useSearchBarState();
  const { searchResponse } = searchBarState;

  const countResources = searchResponse?.resources().length() || 0;
  const showResultList = (
    shouldShowResults(searchBarState, searchBarState.searchTerm)
    && (!searchResponse || searchResponse.resources().length() > 0)
  );

  if (!showResultList) {
    return null;
  }

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        className={classes.title}
        color={'primary'}
        variant={'h4'}
        weight={'medium'}
      >
        {'Results'}
      </Typography>
      {searchResponse?.resources().list().map((searchResultResource, i) => {
        return (
          <ResultComponent
            className={classes.result}
            hideBorder={i === countResources - 1}
            key={searchResultResource.link('self').url()}
            searchResultResource={searchResultResource}
            selectedDOMId={selectedDOMId}
          />
        );
      })}
    </Box>
  );
};

ResultList.defaultProps = {
  className: '',
  selectedDOMId: null,
};

ResultList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  selectedDOMId: PropTypes.string,
};

export default withStyles(styles)(ResultList);
